module.exports = __webpack_public_path__ + "img/footerLogoNew.c4be4936.png";